import React from 'react';
import View from 'components/ui/view';
import OrderProductsListItem from './productsListItem';
import { isEngraving } from 'shared/models/product';
import { engravingForItem } from 'shared/models/cart';

export default function OrderProductsList({ order }) {
  const products = order.products.filter(p => !isEngraving(p)) || [];
  const engravings = order.products.filter(isEngraving) || [];

  return (
    <View padding={{ top: 'md', bottom: 'sm' }} className="order-history-row">
      <ul className="plain-list">
        {products.map(item => {
          const engraving = engravingForItem(engravings, item);
          const key = item.cart_id
            ? item.cart_id + item.quantity
            : item.sku_id + item.quantity;
          return (
            <OrderProductsListItem
              key={key}
              item={item}
              engraving={engraving}
            />
          );
        })}
      </ul>
    </View>
  );
}
